function PlusMinus({ qty, onCange, disabled = false, qtyValue = false }) {
	return (
		<div className="plus-minus">
			<button onClick={() => onCange(parseInt(qtyValue ? qtyValue : qty) - 1)}>
				-
			</button>
			<div>{qty}</div>
			{!disabled ? (
				<button onClick={() => onCange(parseInt(qtyValue ? qtyValue : qty) + 1)}>
					+
				</button>
			) : (
				<button className="disabled">
					+
				</button>
			)}
		</div>
	);
}

export default PlusMinus;
